import { render, staticRenderFns } from "./pricetotal.vue?vue&type=template&id=2a19148d&"
import script from "./pricetotal.vue?vue&type=script&lang=js&"
export * from "./pricetotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a19148d')) {
      api.createRecord('2a19148d', component.options)
    } else {
      api.reload('2a19148d', component.options)
    }
    module.hot.accept("./pricetotal.vue?vue&type=template&id=2a19148d&", function () {
      api.rerender('2a19148d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JEOI2ILSftNn/JS/comp/pricetotal.vue"
export default component.exports